import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import PublicLayout from "web/components/PublicLayout";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import GetQuoteComponent from "../StartPage/GetQuote";
import img from "../../../../assets/images/1set.png";
import lead1 from "../../../../assets/images/01.png";
import lead2 from "../../../../assets/images/02.png";
import lead3 from "../../../../assets/images/03.png";
import lead4 from "../../../../assets/images/04.png";
import lead5 from "../../../../assets/images/05.png";
import lead6 from "../../../../assets/images/06.png";
import lead7 from "../../../../assets/images/07.png";
import lead8 from "../../../../assets/images/08.png";
import lead9 from "../../../../assets/images/09.png";
import lead10 from "../../../../assets/images/10.png";
import DigitalSupplier from "../../../../assets/images/1ManagedServices.svg";
import GreenCheckIcon from "web/assets/svg/GreenCheckMark"
import AOS from "aos";
import {
  Container,
  Wrapper,
  Banner,
  ButtonTwo,
} from "web/pages/public/landing-page/About/AboutStyled";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const About = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const faqRef = useRef(null);
  const membershipRef = useRef(null);
  const newsroomRef = useRef(null);
  const libraryRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
      once: true,
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    if (location.hash === "#faq") {
      if (faqRef.current) {
        // faqRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = faqRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#membership") {
      if (membershipRef.current) {
        // membershipRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = membershipRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#newsroom") {
      if (newsroomRef.current) {
        // newsroomRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = newsroomRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#library") {
      if (libraryRef.current) {
        // libraryRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = libraryRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  let history = useHistory();
  const signUp = () => {
    localStorage.setItem("guestUser", false);
    localStorage.setItem("postInventory", false);
    localStorage.setItem("memberShipType", "");
    history.push("/registration");
  };
  const palletSupplier = () => {
    history.push("/pallet-supplier-and-broker-solutions");
  };

  const palletBuyer = () => {
    history.push("/pallet-buyer-solutions");
  };

  const contactUs = () => {
    history.push("/contact-us");
  };

  return (
    <>
      <Helmet title="PalletTrader | About Us">
        <meta
          name="description"
          content="Learn how PalletTrader is transforming the pallet industry with an online marketplace and managed solutions that simplifies how pallets are sourced and managed."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/about-us" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <Container>
          <Wrapper>
            <Banner>
              <div className="quote">
                <GetQuoteComponent />
              </div>
              <div
                className="banner-text"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <h2>Experience. </h2>
                <h2 className="mb-4">Innovation. Drive.</h2>
                <h3>Founded in 2022, PalletTrader was built</h3>
                <h3> to revolutionize the pallet industry.</h3>
                {/* <p>
                  For more than 40 years, the Bettaway family of companies has
                  been delivering value to our customers through the relentless
                  pursuit of innovative supply chain solutions.
                </p> */}
              </div>
            </Banner>
            <section className="the_experience">
              <h2>The Experience to Find the Best Solution. </h2>
              <h2>The Drive To Invent One.</h2>
              <p id="experience">
                PalletTrader was founded by the owners of Bettaway, a 40+ year
                supply chain services company with core focuses in
                transportation, logistics, distribution, and pallet management.
              </p>
              <img
                src={img}
                alt="icon"
                data-aos="fade-up"
                data-aos-delay="100"
              />
            </section>
            {/* <section
              className="the_experience_detail"
              data-aos="fade-up"
              data-aos-delay="100"
             >
              <div className="grid-box">
                <p className="bold">No. of Employees:</p>
                <p>300+</p>
              </div>
              <div className="grid-box">
                <p className="bold">Founded, Owned:</p>
                <p>1982, Privately Owned & Operated – Certified M/WBE</p>
              </div>
              <div className="grid-box">
                <p className="bold">Recent Accolades:</p>
                <p>
                  FreightWaves F3 “Best in Show” PalletTrader, Johnson &
                  Johnson, Coyote Logistics, C.H. Robinson’s “Carrier of the
                  Year”
                </p>
              </div>
              <div className="grid-box">
                <p className="bold">Past Awards:</p>
                <p>
                  PepsiCo Chairman Award (for innovation in pallet management)
                  Nestle’s “Carrier of the Year” & “World Class Customer
                  Service” Award, JB Hunt’s “Carrier of the Year,” Arrive
                  Logistics’ “Strategic Carrier Partner of the Year”
                </p>
              </div>
            </section> */}
            <section className="our_expertise indispensable">
              <div className="expertise_overlay resource">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h2 className="max-w">
                    An Indispensable Resource for Suppliers and Buyers.
                  </h2>
                  <p className="max-w">
                    Acclaimed by suppliers and buyers a like for its ease of use
                    and scalability, with millions of pallets transacted,
                    PalletTrader is revolutionizing pallet procurement.
                  </p>
                  <div className="grid">
                    <button onClick={palletSupplier}>
                      TAKE ME TO SUPPLIER SOLUTIONS
                    </button>
                    <button onClick={palletBuyer}>
                      TAKE ME TO BUYER SOLUTIONS
                    </button>
                  </div>
                </div>
                <div className="digital_supplier_img">
                  <img
                    src={DigitalSupplier}
                    alt="icon"
                    data-aos="fade-down"
                    data-aos-delay="100"
                  />
                </div>
              </div>
            </section>
            <section className="pallet_faq" id="faq" ref={faqRef}>
              <div className="faq-head">
                <h2>PalletTrader FAQs</h2>
                {/* <p>
                  Senti cata vidissere rei it, num etiu escit, dienatium erore
                  nimante onerte ut atium vitreti, strarivis. Dienatium vitreti,
                  nimante erut atium.
                </p> */}
              </div>
              <div className="number-set">
                <div
                  className="item-container first"
                  data-aos="fade-down"
                  data-aos-delay="000"
                >
                  <div className="number-box">
                    <span className="number">1</span>
                    <span className="number-shadow">1</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader offers two core solutions built around our
                      centralized marketplace: PalletTrader.com is our
                      self-service option where users can register as a Guest or
                      Member, or PalletTrader+ for fully managed or customized solutions.
                    </p>
                  </div>
                </div>
                <div
                  className="item-container first secound"
                  data-aos="fade-down"
                  data-aos-delay="100"
                >
                  <div className="number-box">
                    <span className="number">2</span>
                    <span className="number-shadow">2</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader was designed to bring value to all pallet
                      user types, including pallet buyers, traditional pallet
                      suppliers, pallet brokers, or businesses looking to get
                      rid of excess pallets.
                    </p>
                  </div>
                </div>
                <div
                  className="item-container first"
                  data-aos="fade-down"
                  data-aos-delay="200"
                >
                  <div className="number-box">
                    <span className="number">3</span>
                    <span className="number-shadow">3</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader is made for businesses of any size, from
                      large scale shippers or pallet manufacturers, to single
                      location mom-and-pops, and everything in between.{" "}
                    </p>
                  </div>
                </div>
                <div
                  className="item-container first secound"
                  data-aos="fade-down"
                  data-aos-delay="300"
                >
                  <div className="number-box">
                    <span className="number">4</span>
                    <span className="number-shadow">4</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader is mobile friendly so it can be used from
                      anywhere, at any time.{" "}
                    </p>
                  </div>
                </div>
                <div
                  className="item-container first"
                  data-aos="fade-down"
                  data-aos-delay="400"
                >
                  <div className="number-box">
                    <span className="number">5</span>
                    <span className="number-shadow">5</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader was built with network visibility and
                      operating ease in mind. Admins can create and set location
                      and user permissions all from one centralized place.
                    </p>
                  </div>
                </div>
                <div
                  className="item-container first secound"
                  data-aos="fade-down"
                  data-aos-delay="500"
                >
                  <div className="number-box">
                    <span className="number">6</span>
                    <span className="number-shadow">6</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader gives buyers ultimate flexibility on how they
                      go to market. Users can tender loads directly to their
                      incumbents, or they can leverage the digital
                      nationwide network to procure from new supplier partners.
                    </p>
                  </div>
                </div>
                <div
                  className="item-container first"
                  data-aos="fade-down"
                  data-aos-delay="600"
                >
                  <div className="number-box">
                    <span className="number">7</span>
                    <span className="number-shadow">7</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader offers a comprehensive specification library
                      for common size pallets and types.
                    </p>
                  </div>
                </div>
                <div
                  className="item-container first secound"
                  data-aos="fade-down"
                  data-aos-delay="700"
                >
                  <div className="number-box">
                    <span className="number">8</span>
                    <span className="number-shadow">8</span>
                  </div>
                  <div className="txt-wrp">
                    <p>All payments are secure, and all users are vetted.</p>
                  </div>
                </div>
                <div
                  className="item-container first"
                  data-aos="fade-down"
                  data-aos-delay="800"
                >
                  <div className="number-box">
                    <span className="number">9</span>
                    <span className="number-shadow">9</span>
                  </div>
                  <div className="txt-wrp">
                    <p>
                      PalletTrader is in the U.S. today but looking to expand
                      into CAN in 2025.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section
              className="pallet_faq wrp-bg"
              id="membership"
              ref={membershipRef}
            >
              <div className="faq-head">
                <h2>Choose the Membership Plan that’s Right for You.</h2>
                {/* <p>
                  Senti cata vidissere rei it, num etiu escit, dienatium
                  vitreti, interore nimante nimante omnerte rtellest vil erut
                  atium.
                </p> */}
              </div>
              <div className="buyer">
                <div data-aos="fade-down" data-aos-delay="000">
                  <div className="red-bg">
                    <h2>Guest</h2>
                    <p>Self Service Buyer</p>
                  </div>
                  <div className="buyer_body">
                    <ul>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>3.0%
                        transaction fee
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>No monthly
                        subscription
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Credit
                        card payments
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Buy
                        pallets on the marketplace
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Single
                        location setup
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Centralized reporting & POD access
                      </li>
                    </ul>
                    <div className="text-center">
                      <h5>Free</h5>
                      <div className="guest-button">
                        <button onClick={() => {
                          localStorage.setItem('guestUser', true);
                          localStorage.setItem('postInventory', true);
                          localStorage.setItem('memberShipType', 'guest');
                          history.push("/registration");
                        }}>Continue as Guest</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-aos="fade-down" data-aos-delay="300">
                  <div className="red-bg orange">
                    <h2>Member</h2>
                    <p>Self Service Buyer or Supplier</p>
                  </div>
                  <div className="buyer_body orange-b">
                    <ul>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>0.0% Seller transaction fee
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>3.0% Buyer transaction fee
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Free
                        subscription for one year
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Credit
                        card or ACH payments
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Buy or
                        sell pallets on the marketplace
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Single
                        location to multi-location setup
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Centralized reporting & POD access
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Post your needs to the open market
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Price needs often, or lock in capacity
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Post your inventory to sell
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Access to bid on new opportunities
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Transact on the marketplace, or privately
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Connect with the PT community
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Access to real-time market data
                      </li>
                    </ul>
                    <div className="text-center">
                      <div>
                        <span style={{ color: "#0075ff", fontSize: "18px" }}>
                          <del>$79.00/month </del>
                        </span>
                        <span style={{ fontWeight: "800", fontSize: "22px" }}>
                          / $0.00
                        </span>
                      </div>
                      <h5
                        style={{
                          fontSize: "14px",
                          color: "rgb(9, 85, 135);",
                          marginTop: "10px",
                          letterSpacing: "-0.66px",
                          fontFamily: "robotobold",
                        }}
                      >
                        With promo listed when you register
                      </h5>
                      <div className="guest-button">
                        <button onClick={() => {
                          localStorage.setItem('guestUser', false);
                          localStorage.setItem('postInventory', true);
                          localStorage.setItem('memberShipType', 'buyerSeller');
                          history.push("/registration");
                        }}>Continue as Member</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-aos="fade-down" data-aos-delay="600">
                  <div className="red-bg yellow">
                    <h2>PalletTrader+</h2>
                    <p>Managed Solutions</p>
                  </div>
                  <div className="buyer_body yellow-b">
                    <ul>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>Pallet
                        solutions for every pallet need
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Single
                        location, to national management
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Supply &
                        redemption programs
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>Flexible
                        terms & pricing, fixed or cost plus
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>RFP
                        preparation and execution
                      </li>
                      <li>
                        {" "}
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Value engineering & TCO optimization
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Dedicated account reps
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Request, track & modify orders
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Claims portal and on-demand QC team
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Real-time KPI dashboard & reporting
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Access to real-time market data
                      </li>
                      <li>
                        <i class="fa fa-check" aria-hidden="true"></i>
                        Centralized invoice & POD repository
                      </li>
                    </ul>
                    <div className="text-center">
                      <div className="guest-button">
                        <button onClick={() => {
                          history.push('/contact-us')
                        }}>Learn More</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="center-btn">
                <button onClick={signUp}>SIGN UP</button>
              </div> */}
            </section>
            <section className="pallet_faq lead">
              <div className="faq-head">
                <h2>The Vision and Experience to Lead.</h2>
                <p>
                  Senti cata vidissere rei it, num etiu escit, dienatium
                  vitreti, interore nimante omnerte ut atium vitreti,invit re mo
                  strarivis. Dienatium vitreti, vil erut atium.
                </p>
              </div>
              <div className="lead-group">
                <div className="lead-box">
                  <img
                    src={lead1}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="000"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead2}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="200"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead3}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="600"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead4}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="800"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead5}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="1000"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead6}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="1200"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead7}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="1400"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead8}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="1600"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead9}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="1800"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
                <div className="lead-box">
                  <img
                    src={lead10}
                    alt="lead-img"
                    data-aos="fade-right"
                    data-aos-delay="2000"
                  />
                  <div className="over-text">
                    <div>
                      <h4>Name Goes Here</h4>
                      <p>Titles Go Here</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="careers">
                <div className="faq-head">
                  <h2>
                    Be Part of the Team that is Revolutionizing the Industry.
                  </h2>
                  <p>
                    Senti cata vidissere rei it, num etiu escit, dienatium
                    vitreti, interore nimante omnerte ut atium vitreti,invit re
                    mo strarivis. Dienatium vitreti, vil erut atium.
                  </p>
                  {/* <button>VIEW CAREERS</button> */}
                </div>
              </div>
            </section>
            <section
              className="our_expertise suppliers mb-0"
              id="newsroom"
              ref={newsroomRef}
            >
              <div className="expertise_overlay newsroom">
                <div data-aos="fade-right" data-aos-delay="100">
                  <h2>The Newsroom. </h2>
                  <h2 className="max-w">
                    See what the Industry is Saying About Us.
                  </h2>
                  {/* <p className="max-w">
                    Senti cata vidissere rei it, num etiu escit, dienatium
                    vitreti, interore nimante omnerte rtellest vil ut vit re mo
                    ut adestri strarivis.
                  </p> */}
                  <div className="grid">
                    <button>
                      <a
                        href="https://newsroom.pallettrader.com/"
                        target="_blank"
                      >
                        GO TO THE NEWSROOM
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </section>
            <section className="pallet_faq" id="library" ref={libraryRef}>
              <div className="faq-head">
                <h2 className="market">Contact Us. Search the Marketplace.</h2>
                <h2 className="market">Experience Innovation.</h2>
                {/* <p>
                  Senti cata vidissere rei it, num etiu escit, dienatium
                  vitreti, interore nimante omnerte ut atium vitreti,invit re mo
                  strarivis. Dienatium vitreti, vil erut atium.
                </p> */}
                <ButtonTwo>
                  <button onClick={contactUs}>CONTACT US</button>
                  <button
                    onClick={() => {
                      history.push("/search-inventory");
                    }}
                  >
                    SEARCH MARKETPLACE
                  </button>
                </ButtonTwo>
              </div>
            </section>
          </Wrapper>
        </Container>
        <LandingFooter />
      </PublicLayout>
    </>
  );
};

export default About;
